module.exports = __webpack_public_path__ + "static/media/matlab.d9f74f0a.svg";